import { VorsorgeInfo } from "../contexts/heyFlowLead";

/**
 * Online-Einlösung eines Vorsorgeplans: Der Kunde kommt aus seinem Vorsorge-Konto in dieses Angebot.
 * Kremierung (zum gesicherten Preis), Energiezuschlag und das Guthaben sind vom Server gesperrt,
 * der Kunde zahlt hier nur die Differenz. Der Zustand entscheidet, ob noch bezahlt werden darf.
 */

export type VorsorgeStatus = "offen" | "abgelaufen" | "zurueckgezogen" | "bezahlt";

export function vorsorgeStatus(vorsorge: VorsorgeInfo, now: Date = new Date()): VorsorgeStatus {
  if (vorsorge.completedAt) return "bezahlt";
  if (vorsorge.cancelledAt) return "zurueckgezogen";
  if (Date.parse(vorsorge.expiresAt) < now.getTime()) return "abgelaufen";
  return "offen";
}

export function vorsorgeStatusText(status: VorsorgeStatus): string | undefined {
  switch (status) {
    case "bezahlt":
      return "Diese Einlösung ist bereits bezahlt. Den Stand deines Auftrags siehst du in deinem Vorsorge-Konto.";
    case "zurueckgezogen":
      return "Diese Einlösung wurde in deinem Vorsorge-Konto zurückgezogen. Du kannst sie dort jederzeit neu starten.";
    case "abgelaufen":
      return "Dieses Angebot ist abgelaufen. Starte die Einlösung in deinem Vorsorge-Konto bitte neu, dann bekommst du ein frisches Angebot.";
    case "offen":
      return undefined;
  }
}

export function formatDateDe(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
}
